import { AI_WINDOW_DAYS } from '@steado/admin-contract/ai-ops';
import { z } from 'zod';

/**
 * The windows this screen offers.
 *
 * Stops at 30 deliberately, where AI operations offers 90: `llm_calls` is
 * swept at LLM_CALL_RETENTION_DAYS, which is 30. A 90-day option here would
 * quietly return a month of data under a quarter's heading, and on a screen
 * whose whole job is "how much did this cost", that is the worst kind of
 * wrong — plausible.
 */
export const AI_SPEND_WINDOW_OPTIONS = [7, 30] as const;

/**
 * Only the offered windows. A hand-edited `?days=90` used to pass and label
 * a month of data as a quarter; now it lands on 30.
 */
export const aiSpendWindowSchema = z.coerce
  .number()
  .int()
  .refine((days) => (AI_SPEND_WINDOW_OPTIONS as readonly number[]).includes(days));

export const aiSpendSearchSchema = z.object({
  days: aiSpendWindowSchema.default(AI_WINDOW_DAYS).catch(AI_WINDOW_DAYS),
  sort: z.enum(['cost', 'calls']).default('cost').catch('cost'),
  entitlement: z.enum(['free', 'premium']).optional().catch(undefined),
  /** Part of a name or phone number. */
  search: z.string().optional().catch(undefined),
});

export type AiSpendSearch = z.infer<typeof aiSpendSearchSchema>;
